import React from 'react'
import { useAppState } from 'context/AppContext'
import { i18n } from 'next-i18next'
import { SnapCarouselContainer, SnapCarouselTrack, SnapCarouselSlide } from './styled'

interface SnapCarouselProps {
  children: React.ReactNode
  options?: {
    perPage?: number
    gap?: number
    hasLastChildPadding?: boolean
    lastChildFullWidth?: boolean
    paddingCarouselCard?: number
  }
  dataTestId?: string
  containerWidth?: number
  isMobile?: boolean
  isRTL?: boolean
}

const SnapCarousel: React.FC<SnapCarouselProps> = ({ children, options = {}, dataTestId, containerWidth = 1200, isMobile = false, isRTL = false }) => {
  const { perPage = 1, gap = 16, hasLastChildPadding = false, lastChildFullWidth = false, paddingCarouselCard = 0 } = options

  const { language } = useAppState()
  const direction = i18n?.dir(language || i18n.language)
  const isRTLDirection = isRTL || direction === 'rtl'

  const childrenArray = React.Children.toArray(children)
  const lastIndex = childrenArray.length - 1

  return (
    <SnapCarouselContainer data-testid={dataTestId} $containerWidth={containerWidth} $isMobile={isMobile} $isRTL={isRTLDirection}>
      <SnapCarouselTrack $perPage={perPage} $gap={gap} $containerWidth={containerWidth} $isMobile={isMobile} $isRTL={isRTLDirection} $lastChildFullWidth={lastChildFullWidth}>
        {childrenArray.map((child, index) => {
          const slideKey = React.isValidElement(child) && child.key != null ? child.key : `snap-carousel-slide-${index}`
          return (
            <SnapCarouselSlide
              key={slideKey}
              $isRTL={isRTLDirection}
              $perPage={perPage}
              $isMobile={isMobile}
              $hasLastChildPadding={hasLastChildPadding}
              $isLastChild={index === lastIndex}
              $lastChildFullWidth={lastChildFullWidth}
              $paddingCarouselCard={paddingCarouselCard}
            >
              {child}
            </SnapCarouselSlide>
          )
        })}
      </SnapCarouselTrack>
    </SnapCarouselContainer>
  )
}

export default SnapCarousel
